<template>
  <div class="card border-left-theme shadow mb-5">
    <div class="card-body">
      <div class="table-responsive">
        <table
          :id="dataTable.id"
          class="table table-striped"
          width="100%"
          cellspacing="0"
        >
          <thead>
            <tr>
              <th class="text-center">Nº do Registro</th>
              <th class="text-center">Status</th>
              <th class="text-center">Ano</th>
              <th class="text-center">Data de Abertura</th>
              <th>Responsável</th>
              <th>Tipo</th>
              <th>Descrição</th>
              <th class="text-center">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="registry in registries" :key="registry.id">
              <td class="text-center">{{ registry.numero }}</td>
              <td
                class="text-center"
                v-html="statusRegistry(registry.status)"
              />
              <td class="text-center">
                {{ dateSqlToYearBR(registry.dataAbertura) }}
              </td>
              <td class="text-center">
                {{ dateSqlToDateBR(registry.dataAbertura) }}
              </td>
              <td>{{ registry.responsavel }}</td>
              <td>{{ registry.tipo }}</td>
              <td>{{ registry.descricao.substring(0, 250) }}</td>
              <td class="text-center">
                <router-link
                  :to="`/details/${registry.id}`"
                  class="btn btn-outline-primary"
                  title="Detalhes"
                >
                  <i class="fas fa-file-alt"></i>
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css'
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-bs4/js/dataTables.bootstrap4'
import '@/utils/basicDataTableExtend'
import { statusRegistry } from '@/utils/strings'
import { dateSqlToYearBR, dateSqlToDateBR } from '@/utils/date'

export default {
  name: 'ListRegistries',

  props: {
    registries: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      dataTable: {
        id: 'dataTableListRegistry',
        columnDefs: [
          {
            targets: [0],
            width: 120,
            orderData: [2, 0],
          },
          {
            targets: [1],
            width: 130,
          },
          {
            targets: [2],
            width: 40,
          },
          {
            targets: [3],
            width: 180,
          },
          {
            targets: [7],
            searchable: false,
            orderable: false,
            width: 20,
          },
        ],
      },
      statusRegistry,
      dateSqlToYearBR,
      dateSqlToDateBR,
    }
  },

  methods: {
    createDataTable() {
      window.$(`#${this.dataTable.id}`).DataTable({
        columnDefs: this.dataTable.columnDefs,
      })

      window
        .$('.datatable-header')
        .addClass('d-block d-md-flex justify-content-between')
      window
        .$('.datatable-footer')
        .addClass('d-block d-md-flex justify-content-between')
    },
  },

  mounted() {
    this.createDataTable()
  },
}
</script>
